import React from "react";
import { Link } from "gatsby";

const isInternalLink = (url: string): boolean => {
    return (
        url.startsWith("/") || url.startsWith("#") || !url.match(/^https?:\/\//)
    );
};

export const LinkWrapper: React.FC<{
    to: string;
    className?: string;
    children: React.ReactNode;
    onClick?: () => void;
}> = ({ to, className, children, onClick }) => {
    if (isInternalLink(to)) {
        return (
            <Link to={to} className={className} onClick={onClick}>
                {children}
            </Link>
        );
    }
    return (
        <a
            href={to}
            className={className}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
        >
            {children}
            <span className="sr-only"> (opens in a new tab)</span>
        </a>
    );
};
